// Test-only component used to exercise the ErrorBoundary end-to-end.
// It is reachable ONLY when REACT_APP_ENABLE_TEST_HOOKS === "true" (see App.jsx),
// so it can never render in a production build. It throws during render to force
// the nearest ErrorBoundary to catch it.
export default function CrashTest() {
  throw new Error("CrashTest: intentional render failure for ErrorBoundary e2e");
}
